// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-4449ee6c]:root{--sticky-header-height:8.75rem;--environment-footer-height:2 * 1.25rem}.hadrian-icons.dots path[data-v-4449ee6c]{-webkit-transition:all .2s ease;transition:all .2s ease;fill:var(--icon-dots-color,#5d5c5c);stroke:var(--icon-dots-color,#5d5c5c)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
